// assets/help-center.js
document.addEventListener('DOMContentLoaded', function() {
  
  // Initialize Flatpickr for date inputs
  if (typeof flatpickr !== 'undefined') {
    flatpickr(".yon-flatpickr", {
      dateFormat: "m/d/Y",
      allowInput: true
    });
  }

  const wizard = document.getElementById('yon-help-wizard');
  if (!wizard) return;

  const step1 = document.getElementById('yon-step-1');
  const step2 = document.getElementById('yon-step-2');
  const btnBack = document.getElementById('yon-btn-back');
  const categoryInputs = document.querySelectorAll('input[name="yon_category"]');
  
  const hiddenCategory = document.getElementById('yon-hidden-category');
  const hiddenResolution = document.getElementById('yon-hidden-resolution');
  const form = document.getElementById('yon-help-contact-form');
  const submitBtn = document.getElementById('yon-submit-btn');
  const systemAlert = document.getElementById('yon-system-alert');
  const pdfBarrier = document.getElementById('yon-pdf-barrier');

  // DOM Elements for Logic
  const aftersalesType = document.getElementById('yon-aftersales-type');
  const warningShipped = document.getElementById('yon-warning-shipped');
  const aftersalesUsedLogic = document.getElementById('yon-aftersales-used-logic');
  const aftersalesEvidenceGroup = document.getElementById('yon-aftersales-evidence-group');
  const aftersalesUsedRadios = document.querySelectorAll('input[name="yon_aftersales_used"]');
  
  const refundReason = document.getElementById('yon-refund-reason');
  const refundWaitLogic = document.getElementById('yon-refund-wait-logic');
  
  const shippedRadios = document.querySelectorAll('input[name="yon_shipped"]');
  const waitTimeGroup = document.getElementById('yon-wait-time-group');
  const openedGroup = document.getElementById('yon-opened-group');
  const over4wRadios = document.querySelectorAll('input[name="yon_over_4w"]');
  const openedRadios = document.querySelectorAll('input[name="yon_opened"]');

  // Step 1 -> Step 2
  categoryInputs.forEach(input => {
    input.addEventListener('change', function() {
      if (this.checked) {
        const cat = this.value;
        hiddenCategory.value = cat;
        
        // Hide all conditionals
        document.querySelectorAll('.yon-conditional').forEach(el => el.style.display = 'none');
        
        // Show relevant conditionals
        document.querySelectorAll('.yon-conditional').forEach(el => {
          const showFor = el.getAttribute('data-show-for');
          if (showFor && showFor.includes(cat)) {
            el.style.display = 'block';
          }
        });

        // Reset specific logic
        resetLogic(cat);

        // Specific Label overrides
        const msgLabel = document.getElementById('yon-message-label');
        if (cat === 'aftersales') {
          msgLabel.innerHTML = 'Description of the Issue <span class="required">*</span>';
        } else if (cat === 'refund') {
          msgLabel.innerHTML = 'Additional Details <span class="required">*</span>';
        } else {
          msgLabel.innerHTML = 'Details / Message <span class="required">*</span>';
        }

        step1.classList.remove('active');
        step2.classList.add('active');
      }
    });
  });

  // Step 2 -> Step 1
  btnBack.addEventListener('click', function() {
    step2.classList.remove('active');
    step1.classList.add('active');
    categoryInputs.forEach(i => i.checked = false);
  });

  // Aftersales Logic
  aftersalesType.addEventListener('change', function() {
    const val = this.value;
    
    // Reset Aftersales Logic
    warningShipped.style.display = 'none';
    aftersalesUsedLogic.style.display = 'none';
    aftersalesEvidenceGroup.style.display = 'none';
    aftersalesUsedRadios.forEach(r => r.checked = false);
    hideAlerts();
    allowSubmit(); // default allow, we will block if needed

    if (val === 'replacement-shipped') {
      warningShipped.style.display = 'block';
      aftersalesUsedLogic.style.display = 'block';
      blockSubmit(); // Must answer the usage question first
    } else if (val === 'wrong-product' || val === 'damaged' || val === 'install-quality') {
      aftersalesEvidenceGroup.style.display = 'block';
    } else if (val === 'replacement-unshipped') {
      // Nothing extra needed
    }
  });

  aftersalesUsedRadios.forEach(radio => {
    radio.addEventListener('change', function() {
      const isUsed = this.value;
      hideAlerts();
      if (isUsed === 'yes') {
        showAlert('Exchanges are not accepted for products that have been used.', 'error');
        aftersalesEvidenceGroup.style.display = 'none';
        blockSubmit();
      } else if (isUsed === 'no') {
        aftersalesEvidenceGroup.style.display = 'block';
        allowSubmit();
      }
    });
  });

  // Refund Logic
  refundReason.addEventListener('change', function() {
    resetRefundLogic();
    const reason = this.value;
    
    // Hide submit and message until conditions are met
    submitBtn.style.display = 'none';
    document.getElementById('yon-message-group').style.display = 'none';
    pdfBarrier.style.display = 'none';
    
    if (reason === 'wait-long') {
      refundWaitLogic.style.display = 'block';
    } else if (reason) {
      // Changed mind, better alt, price high, other
      requirePDF();
    }
  });

  // Wait Long Logic Tree
  shippedRadios.forEach(radio => {
    radio.addEventListener('change', function() {
      if (this.value === 'yes') {
        waitTimeGroup.style.display = 'none';
        openedGroup.style.display = 'block';
        evaluateWaitLogic();
      } else {
        openedGroup.style.display = 'none';
        waitTimeGroup.style.display = 'block';
        evaluateWaitLogic();
      }
    });
  });

  over4wRadios.forEach(radio => {
    radio.addEventListener('change', evaluateWaitLogic);
  });

  openedRadios.forEach(radio => {
    radio.addEventListener('change', evaluateWaitLogic);
  });

  function evaluateWaitLogic() {
    const isShipped = document.querySelector('input[name="yon_shipped"]:checked')?.value;
    const isOver4w = document.querySelector('input[name="yon_over_4w"]:checked')?.value;
    const isOpened = document.querySelector('input[name="yon_opened"]:checked')?.value;

    hideAlerts();
    allowSubmit(); // default
    document.getElementById('yon-appeasement-claim').style.display = 'none';

    if (isShipped === 'no') {
      if (isOver4w === 'yes') {
        // Unshipped + > 4 weeks
        document.getElementById('yon-appeasement-claim').style.display = 'block';
        document.getElementById('yon-message-group').style.display = 'block';
        allowSubmit();
      } else if (isOver4w === 'no') {
        // Unshipped + < 4 weeks
        showAlert('Your order is still within our normal processing time of 4 weeks. Please be patient while we custom build your system.', 'success');
        blockSubmit();
      }
    } else if (isShipped === 'yes') {
      if (isOpened === 'yes') {
        showAlert('Unfortunately, we do not accept returns for products that have been used as they cannot be resold.', 'error');
        blockSubmit();
      } else if (isOpened === 'no') {
        showAlert('A 3.5% payment processing fee and 40% restocking fee will apply to all returned orders. You are responsible for return shipping costs. Proof of an unused package is required. Please provide your photo/video evidence link inside the Refund PDF Form.', 'warning');
        requirePDF();
      }
    }
  }

  function resetLogic(cat) {
    // Reset aftersales
    aftersalesType.value = '';
    warningShipped.style.display = 'none';
    aftersalesUsedLogic.style.display = 'none';
    aftersalesEvidenceGroup.style.display = 'none';
    aftersalesUsedRadios.forEach(r => r.checked = false);
    
    // Reset refund
    refundReason.value = '';
    resetRefundLogic();
    pdfBarrier.style.display = 'none';
    
    if (cat === 'refund') {
      submitBtn.style.display = 'none';
      document.getElementById('yon-message-group').style.display = 'none';
    } else {
      submitBtn.style.display = 'block';
      document.getElementById('yon-message-group').style.display = 'block';
    }
  }

  function resetRefundLogic() {
    refundWaitLogic.style.display = 'none';
    waitTimeGroup.style.display = 'none';
    openedGroup.style.display = 'none';
    shippedRadios.forEach(r => r.checked = false);
    over4wRadios.forEach(r => r.checked = false);
    openedRadios.forEach(r => r.checked = false);
    document.getElementById('yon-proof-link-group').style.display = 'none';
    document.getElementById('yon-appeasement-claim').style.display = 'none';
    hideAlerts();
  }

  function showAlert(msg, type) {
    systemAlert.className = 'yon-system-alert yon-alert-' + type;
    systemAlert.innerHTML = msg;
    systemAlert.style.display = 'block';
  }

  function hideAlerts() {
    systemAlert.style.display = 'none';
    pdfBarrier.style.display = 'none';
  }

  function blockSubmit() {
    submitBtn.style.display = 'none';
    pdfBarrier.style.display = 'none';
  }

  function allowSubmit() {
    submitBtn.style.display = 'block';
    pdfBarrier.style.display = 'none';
  }

  function requirePDF() {
    submitBtn.style.display = 'none';
    pdfBarrier.style.display = 'block';
    document.getElementById('yon-pdf-upload').value = '';
    document.getElementById('yon-pdf-error').style.display = 'none';
    document.getElementById('yon-pdf-success').style.display = 'none';
  }

  // PDF Upload & Parsing Logic
  const pdfUpload = document.getElementById('yon-pdf-upload');
  if (pdfUpload) {
    pdfUpload.addEventListener('change', async function(e) {
      const file = e.target.files[0];
      const errorSpan = document.getElementById('yon-pdf-error');
      const successSpan = document.getElementById('yon-pdf-success');
      
      errorSpan.style.display = 'none';
      successSpan.style.display = 'none';
      submitBtn.style.display = 'none';

      if (!file) return;

      if (!window.PDFLib) {
        errorSpan.textContent = 'PDF parsing library is still loading. Please try again in a moment.';
        errorSpan.style.display = 'block';
        return;
      }

      try {
        const arrayBuffer = await file.arrayBuffer();
        const pdfDoc = await window.PDFLib.PDFDocument.load(arrayBuffer);
        const form = pdfDoc.getForm();
        
        // Fields defined in our generator script
        const fieldNames = ['OrderNumber', 'Name', 'Email', 'Reason', 'MediaLink', 'Signature', 'Date'];
        let extractedData = {};
        let missingFields = [];
        let invalidFields = [];

        fieldNames.forEach(name => {
          try {
            const field = form.getTextField(name);
            const val = field.getText();
            if (!val || val.trim() === '') {
              missingFields.push(name);
            } else {
              extractedData[name] = val.trim();
            }
          } catch (err) {
            missingFields.push(name);
          }
        });

        // Format Validation
        if (extractedData['Email']) {
          const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
          if (!emailRegex.test(extractedData['Email'])) {
            invalidFields.push('Email (invalid format)');
          }
        }
        
        if (extractedData['OrderNumber']) {
          const orderRegex = /^[0-9]+$/;
          if (!orderRegex.test(extractedData['OrderNumber'])) {
            invalidFields.push('OrderNumber (must be numbers only)');
          }
        }

        let errorMsg = '';
        if (missingFields.length > 0) {
          errorMsg += 'Missing fields: ' + missingFields.join(', ') + '. ';
        }
        if (invalidFields.length > 0) {
          errorMsg += 'Invalid formats: ' + invalidFields.join(', ') + '.';
        }

        if (errorMsg !== '') {
          errorSpan.textContent = 'Please correct your PDF: ' + errorMsg;
          errorSpan.style.display = 'block';
          document.getElementById('yon-pdf-extracted-data').value = '';
        } else {
          successSpan.textContent = 'PDF Verified Successfully. You may now submit your request.';
          successSpan.style.display = 'block';
          
          // Format extracted data into human readable text for the email
          let readableData = '';
          fieldNames.forEach(name => {
            if (extractedData[name]) {
              readableData += `${name}: ${extractedData[name]}\n`;
            }
          });
          document.getElementById('yon-pdf-extracted-data').value = readableData;
          
          // Set Name and Email directly so Shopify accepts the form
          if (extractedData['Name']) document.getElementById('yon-hidden-name').value = extractedData['Name'];
          if (extractedData['Email']) document.getElementById('yon-hidden-email').value = extractedData['Email'];
          
          submitBtn.style.display = 'block'; // Unlock submission
          document.getElementById('yon-message-group').style.display = 'block';
        }

      } catch (err) {
        console.error(err);
        errorSpan.textContent = 'Invalid or corrupted PDF file. Please download the form and try again.';
        errorSpan.style.display = 'block';
      }
    });
  }

  form.addEventListener('submit', function(e) {
    try {
      let valid = true;
      const cat = hiddenCategory.value;
      
      // Clear existing errors
      document.querySelectorAll('.yon-form-group').forEach(el => el.classList.remove('has-error'));

      // Helper to check if an element is visible to the user
      const isVisible = (el) => el && el.offsetParent !== null;

      // Helper to mark an error
      const markError = (id) => {
        const el = document.getElementById(id);
        if (el) {
          const group = el.closest('.yon-form-group');
          if (group) group.classList.add('has-error');
        }
        valid = false;
      };

      if (cat !== 'refund') {
        // General Validation

        // Name
        const nameEl = document.getElementById('yon-name');
        if (isVisible(nameEl)) {
          if (!nameEl.value.trim()) {
            markError('yon-name');
          } else {
            document.getElementById('yon-hidden-name').value = nameEl.value.trim();
          }
        }

        // Email
        const emailEl = document.getElementById('yon-email');
        if (isVisible(emailEl)) {
          const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
          if (!emailRegex.test(emailEl.value)) {
            markError('yon-email');
          } else {
            document.getElementById('yon-hidden-email').value = emailEl.value;
          }
        }

        // Phone
        const phoneEl = document.getElementById('yon-phone');
        if (isVisible(phoneEl)) {
          const phoneRegex = /^[0-9\-\s\(\)]+$/;
          if (!phoneRegex.test(phoneEl.value) || phoneEl.value.length < 5) {
            markError('yon-phone');
          } else {
            document.getElementById('yon-phone-hidden').value = document.getElementById('yon-phone-code').value + ' ' + phoneEl.value;
          }
        }

        // Order Number
        const orderEl = document.getElementById('yon-order-number');
        if (isVisible(orderEl)) {
          const orderRegex = /^[0-9]+$/;
          if (!orderRegex.test(orderEl.value)) {
            markError('yon-order-number');
          } else {
            document.getElementById('yon-hidden-order').value = orderEl.value;
          }
        }

        // Order Date
        const dateEl = document.getElementById('yon-order-date');
        if (isVisible(dateEl) && !dateEl.value.trim()) {
          markError('yon-order-date');
        }

        // Issue Type
        const typeEl = document.getElementById('yon-aftersales-type');
        if (isVisible(typeEl) && !typeEl.value) {
          markError('yon-aftersales-type');
        }

        // Aftersales Evidence Link
        const aftersalesEvidenceEl = document.getElementById('yon-aftersales-evidence');
        if (isVisible(aftersalesEvidenceEl)) {
          if (!aftersalesEvidenceEl.value.trim()) {
            markError('yon-aftersales-evidence');
          } else {
            document.getElementById('yon-hidden-proof').value = aftersalesEvidenceEl.value.trim();
          }
        }

      } else {
        // Refund Validation
        // Ensure a refund reason is selected if the appease claim isn't visible
        if (!refundReason.value) {
           markError('yon-refund-reason');
        }

        // Check if Appeasement claim is active
        const appeaseClaim = document.getElementById('yon-appeasement-claim');
        if (isVisible(appeaseClaim)) {
          const appeaseEmail = document.getElementById('yon-appease-email').value;
          const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
          if (!emailRegex.test(appeaseEmail)) {
            markError('yon-appease-email');
          } else {
            document.getElementById('yon-hidden-email').value = appeaseEmail;
          }

          const appeaseOrder = document.getElementById('yon-appease-order');
          const orderRegex = /^[0-9]+$/;
          if (!orderRegex.test(appeaseOrder.value)) {
            markError('yon-appease-order');
          } else {
            document.getElementById('yon-hidden-order').value = appeaseOrder.value;
          }
        }
      }

      // Populate Hidden Resolution for email context safely
      if (cat === 'aftersales') {
        hiddenResolution.value = aftersalesType.selectedIndex >= 0 ? aftersalesType.options[aftersalesType.selectedIndex].text : '';
      } else if (cat === 'refund') {
        const appeaseClaim = document.getElementById('yon-appeasement-claim');
        if (isVisible(appeaseClaim)) {
          hiddenResolution.value = 'Retention Offer Claimed - Needs 10% Discount';
        } else {
          hiddenResolution.value = refundReason.selectedIndex >= 0 ? refundReason.options[refundReason.selectedIndex].text : '';
        }
      } else {
        hiddenResolution.value = cat;
      }

      if (!valid) {
        e.preventDefault();
        e.stopImmediatePropagation();
        // Scroll to the first error so the user can see it
        const firstError = document.querySelector('.has-error');
        if (firstError) {
          firstError.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
      }
    } catch (err) {
      console.error('Validation crashed:', err);
      e.preventDefault();
      e.stopImmediatePropagation();
      alert('An error occurred during validation. Please ensure all fields are correct.');
    }
  });


  // ---------------------------------------------------------
  // URL Params Auto-Fill & Category Routing (Encrypted)
  // ---------------------------------------------------------
  const urlParams = new URLSearchParams(window.location.search);
  const token = urlParams.get('token');
  
  let paramOrder = null, paramEmail = null, paramPhone = null, paramName = null, paramCategory = null;

  if (token) {
    try {
      const SECRET_KEY = "ZhenkuiWang08011998**";
      
      // Decode URL-safe Base64
      let base64 = token.replace(/-/g, '+').replace(/_/g, '/');
      while (base64.length % 4) { base64 += '='; }
      let binaryStr = atob(base64);
      
      // XOR Decrypt to UTF-8 bytes
      let utf8Bytes = new Uint8Array(binaryStr.length);
      for (let i = 0; i < binaryStr.length; i++) {
         utf8Bytes[i] = binaryStr.charCodeAt(i) ^ SECRET_KEY.charCodeAt(i % SECRET_KEY.length);
      }
      
      // Decode UTF-8 to JSON String
      let decoder = new TextDecoder('utf-8');
      let decryptedText = decoder.decode(utf8Bytes);
      let data = JSON.parse(decryptedText);

      paramOrder = data.order || data.o;
      paramEmail = data.email || data.e;
      paramPhone = data.phone || data.p;
      paramName = data.name || data.n;
      paramCategory = data.category || data.c;
    } catch (err) {
      console.error('Invalid or corrupted token.', err);
    }
  }

  if (paramOrder) {
    const orderInput = document.getElementById('yon-order-number');
    if (orderInput) orderInput.value = paramOrder;
  }
  if (paramEmail) {
    const emailInput = document.getElementById('yon-email');
    if (emailInput) emailInput.value = paramEmail;
    const appeaseEmail = document.getElementById('yon-appease-email');
    if (appeaseEmail) appeaseEmail.value = paramEmail;
  }
  if (paramPhone) {
    const phoneInput = document.getElementById('yon-phone');
    if (phoneInput) phoneInput.value = paramPhone;
  }
  if (paramName) {
    const nameInput = document.getElementById('yon-name');
    if (nameInput) nameInput.value = paramName;
  }

  if (paramCategory && paramCategory !== 'refund') {
    const categoryRadio = document.querySelector(`input[name="yon_category"][value="${paramCategory}"]`);
    if (categoryRadio) {
      categoryRadio.checked = true;
      // Trigger the change event manually to simulate user click
      categoryRadio.dispatchEvent(new Event('change'));
    }
  }
});
